<script>
    import { _ } from 'svelte-i18n';
    import Section from '../components/Section.svelte';
    import Back from '../components/Back.svelte';
    import { goto, first } from '../helpers/navigation.svelte.js';
    import aiIcon from '../assets/icons/ai.svg?raw';

    // The heavy chat UI (Chatbot, the composer, the chat session + Worker driver) loads
    // on demand as ONE chunk — a single dynamic import of the Chatbot directory's entry
    // module, only when this route renders, so it stays out of the main bundle. Evaluated
    // once at init; both await blocks below share the same module promise.
    const chatUi = import('../components/Chat/index.js');

    /* Leave the chat and return to the first step of the booking widget. */
    function goBack() {
        goto(first(), 'left');
    }
</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('chatbot_title')}</title>
</svelte:head>

<!-- Messages flow in the Section's scrollable contents; the composer sits in the
     Section's footer, which is pinned to the bottom. -->
<Section title={$_('chatbot_title')} icon={aiIcon} fill>
    {#snippet back()}
        <Back onclick={goBack} />
    {/snippet}

    {#await chatUi then { Messages }}
        <Messages />
    {/await}

    {#snippet navigation()}
        {#await chatUi then { Composer }}
            <Composer />
        {/await}
    {/snippet}
</Section>
